/*
 * 格式化日期 create by guoxingwang 2017-07-15
 * type 01 '-' 02 '/' 03  '.'
 * format  01 年月日  02 年月日 时分 03 年月日时分秒
 * */
export const formatDate = (date, type, format) => {
  if (!date) {
    return ""
  } else {
    let nowDate = new Date(date);
    let y = nowDate.getFullYear();
    let m = nowDate.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    let d = nowDate.getDate();
    d = d < 10 ? "0" + d : d;
    let h = nowDate.getHours();
    h = h < 10 ? "0" + h : h;
    let min = nowDate.getMinutes();
    min = min < 10 ? "0" + min : min;
    let s = nowDate.getSeconds();
    s = s < 10 ? "0" + s : s;
    let separatorType = "";
    switch (type) {
      case '01':
        separatorType = '-';
        break;
      case '02':
        separatorType = '/';
        break;
      case '03':
        separatorType = '.';
        break;
      default:
        separatorType = '-';
        break;
    }
    if (format == '01') { //年月日
      return y + separatorType + m + separatorType + d;
    } else if (format == '02') { //年月日 时分
      return y + separatorType + m + separatorType + d + " " + h + ":" + min;
    } else if (format == '03') { //年月日  时分秒
      return y + separatorType + m + separatorType + d + " " + h + ":" + min + ":" + s;
    } else {
      alert('时间格式输入有误')
    }
  }
};

/**
 * 提示信息
 * type类型  info提示  success成功 warning警告 error错误 loading加载
 * */
export const tips = (target, s,type) => {
  target.$Message[type]({
    content: s,
    duration: 3,
    closable: true,
    onClose:()=>{
        target.$Message.destroy();
    }
  });
};

/**
 * 比较两个时间大小
 * 第一个参数大返回true，否则返回false
 * */
export const compareDate = (date1, date2) => {
  let oDate1 = new Date(date1);
  let oDate2 = new Date(date2);
  if (oDate1.getTime() >= oDate2.getTime()) {
    return true;
  } else {
    return false;
  }
};

/**
 * 数组去除空值
 * 
 * */
export const notEmpty = (arr) =>{
  var arr = [];
  arr.map(function(val, index) {
      //过滤规则为，不为空串、不为null、不为undefined
      if (val !== "" && val != undefined) {
          arr.push(val);
      }
  });
  return arr;
}

/*
 *格式化中间有T的替换为空格
 * */
export const replaceT = (val) => {
	if (!val) return '';
	val = val.toString();
	return val.replace(/T/g," ");
}
/*
 *支付方式
 * */
export const payType = (val) => {
	switch(val){
    case 1:
      return "现金";
      break;
    case 2:
      return "医保";
      break;
    case 3:
      return "微信";
      break;
    case 4:
      return "支付宝";
      break;
    case 5:
      return "银联";
      break;
    case 6:
      return "其他";
      break;
  }
}
  /**
 * 支付状态
 * @param {*} state 
 */
export const payState2 = (state) => {
  switch(state){
    case '0':
      return '支付中';
      break;
    case '1':
      return '已支付';
      break;
    default:
      return state;
      break;
  }
}
/*
 *预约挂号状态
 by fangjinqiang
 2019.05.16
 * */
export const appRegState = (val) => {
	switch(val){
    case '1':
      return "待诊";
      break;
    case '2':
      return "接诊中";
      break;
    case '3':
      return "已诊";
      break;
    case '4':
      return "预约";
      break;
    case '5':
      return "已过期";
      break;
    case '6':
      return "已过号";
      break;
  }
}
/*
 *患者来源
 by fangjinqiang
 2019.05.16
 * */
export const patiSourFilter = (val) => {
	switch(val){
    case '1':
      return '其他';
      break;
    case '2':
      return "微信";
      break;
    case '3':
      return "媒体报道";
      break;
    case '4':
      return "微博";
      break;
    case '5':
      return "活动推广";
      break;
    case '6':
      return "亲友推荐";
      break;
    case '7':
      return "附近居民";
      break;
    case '8':
      return "复诊";
      break;
    case '9':
      return "单位指定";
      break;
    case '10':
      return "短信";
      break;
  }
}
/**
 * 订单状态
 * @param {*} state 
 */
export const formatState = (state) => {
    switch(state){
      case '0':
        return '临时订单';
        break;
      case '1':
        return '未支付';
        break;
      case '2':
        return '送检中(未支付)';
        break;
      case '3':
        return '检验中(未支付)';
        break;
      case '4':
        return '生成报告(未支付)';
        break;
      case '5':
        return '支付中';
        break;
      case '6':
        return '送检中(支付中)';
        break;
      case '7':
        return '检验中(支付中)';
        break;
      case '8':
        return '生成报告(支付中)';
        break;
      case '9':
        return '送检中';
        break;
      case '10':
        return '检验中';
        break;
      case '11':
        return '生成报告';
        break;
      case '12':
        return '已取消';
        break;
      case '13':
        return '已支付';
        break;
      default:
        return state;
        break;
    }
  }
/**
 * 数组转字符串
 * 
 * */
export const arrTostring = (arr) =>{
  if(arr){
    return arr.join(',');
  }
  
}

/**
   * 使用test方法实现模糊查询
   * @param  {Array}  list     原数组
   * @param  {String} keyWord  查询的关键词
   * @return {Array}           查询的结果
   */
  export const fuzzyQuery = (list, keyWord) => {
    var reg =  new RegExp(keyWord);
    var arr = [];
    for (var i = 0; i < list.length; i++) {
      if (reg.test(list[i])) {
        arr.push(list[i]);
      }
    }
    return arr;
  }

  /**
 * 收费状态
 * @param {*} state 
 */
export const payState = (state) => {
  switch(state){
    case 1:
      return '未支付';
      break;
    case 2:
      return '已支付';
      break;
    case 4:
      return '已取消';
      break;
    case 7:
      return '已退款';
      break;
    default:
      return state;
      break;
  }
}
/*
 *结算状态
 by fangjinqiang
 2019.05.31
 * */
export const settleState = (state) => {
	switch(state){
    case 0:
      return "未结算";
      break;
    case 1:
      return "全部已结算";
      break;
    case 2:
      return "部分已结算";
      break;
    default:
        return state;
        break;
  }
}
  /**
 * 交易类型
 * @param {*} state 
 */
export const tradeState = (state) => {
  switch(state){
    case 'JSAPI':
      return '公众号支付';
      break;
    case 'NATIVE':
      return '扫码支付';
      break;
    case 'APP':
      return 'APP支付';
      break;
    default:
      return state;
      break;
  }
}
/**控制字符长度超出显示省略号 
* @param {字符串} value 
* @param {显示长度} actLen 
*/
export const ellipsis = (value,actLen) => {
  if (!value) return '';
  if (value.length > actLen) {
    return value.slice(0,actLen) + '...';
  }
  return value
}
/**
 * 是否登录，登录存储vuex
 */
export const isSession = () => {
  //在页面加载时读取sessionStorage里的状态信息
  if (sessionStorage.getItem("store") ) {
    this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
  } 
  //在页面刷新时将vuex里的信息保存到sessionStorage里
  window.addEventListener("beforeunload",()=>{
      sessionStorage.setItem("store",JSON.stringify(this.$store.state))
  })
}

export const dictionaryValue= (value,array)=>{
  if(array.length>0){
    let index = array.findIndex(item=>item.code==value+'');
    if(index!=-1){
      return array[index].name;
      console.log(array[index].name);
    }
  }
}


// WEBPACK FOOTER //
// ./src/tools/index.js